
import AppMailTemplateEditor from "@/components/mail/MailTemplateEditor.vue";
import AppPropSelect from "@/components/mail-template-editor/MailTemplatePropSelect.vue";
import { MessagesService } from "@/services/messages-service";
import { EmailTemplateInfo } from "@/utils/email-template-info";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import { FrequencyDocumentEditState } from "../../utils/frequency-document-edit-state";
import { SaleEmailTemplate } from "@/models/sale-email-template";
import { GoTemplateDataRoot } from "@/utils/go-template-data-structure/root";
import { MailSettingsService } from "@/services/mail-settings-service";
import { FrequencySendMailMode } from "@/models/base/frequency-document";
import { getEnumValueFromKey, getNumberEnumKeys} from "@/utils/enum";

export default Vue.extend({
	data() {
		return {
			cursorPosition: 0,
			contentAsText: "",
			templates: [] as EmailTemplateInfo[],
		};
	},
	props: {
		state: {
			type: Object as () => FrequencyDocumentEditState,
			required: true
		}
	},
	computed: {
		templateItems():ISelectItem<EmailTemplateInfo>[] {
			return this.templates.map(t => {
				return {
					text: t.Name,
					value: t
				};
			});
		},
		props():GoTemplateDataRoot {
			return new SaleEmailTemplate().getContentData();
		},
		sendMailEnabledItems():ISelectItem<FrequencySendMailMode>[] {
			return getNumberEnumKeys(FrequencySendMailMode).map(k=>{
				return {
					text: this.$ct("common.frequency-document-send-mail-mode." + k),
					value: getEnumValueFromKey(FrequencySendMailMode, k)
				};
			});
		},
		sendMailEnabled():boolean {
			return this.state.doc.SendMailEnabled != FrequencySendMailMode.OFF;
		}
	},
	methods: {
		addProp(prop: string) {
			(this.$refs.editor as any).insertText(prop);
		},
		async loadTemplate(temp:EmailTemplateInfo) {
			let lang = "nl-be";
			if (this.state.doc.Sale) {
				lang = this.state.doc.Sale.getLng();
			}
			let template = await MessagesService.getSaleTemplate(temp.ID);
			this.state.doc.MailSubject = template.Subject.getTranslation(lang);
			this.state.doc.MailContentTemplate = template.Content.getTranslation(lang);
			this.state.doc.SendReadConfirmation = template.SendReadConfirmation;
		}
	},
	async created() {
		this.templates = await MessagesService.getSaleTemplates();
		let mailSettings = await MailSettingsService.getDefaultSettings();
		if (this.state.doc.ID == 0){
			this.state.doc.MailFrom = mailSettings.EmailFrom;
			if (!this.state.doc.Sale) return;
			if (!this.state.doc.Sale.InvoiceAddress) return;
			this.state.doc.MailTo = this.state.doc.Sale.InvoiceAddress.Email;
		}
	},
	components: {
		AppPropSelect,
		AppMailTemplateEditor
	},
	i18nEx: {
		componentPrefix: "components.frequency-documents"
	}
});
